@for (navGroup of navMenus; track navGroup) {
  <ul class="list-unstyled components">
    <li>
      <!-- class="dropdown-toggle" [ngClass]="(navGroup.expand)?'':'collapsed'"-->
      <a data-bs-toggle="collapse" aria-expanded="{{navGroup.expand}}"
        (click)="expandSelectedMenu(navGroup)">{{navGroup.name}}
        <span [ngClass]="(navGroup.expand)?'opened':'closed'"></span>
      </a>
      <!-- <a data-bs-toggle="collapse" aria-expanded="{{navGroup.expand}}"
      (click)="expandSelectedMenu(navGroup)">{{navGroup.title}}
      <span [ngClass]="(navGroup.expand)?'opened':'closed'"></span>
    </a> -->
    @for (navItem of navGroup.navlinks; track navItem) {
      <ul class="collapse list-unstyled" [ngClass]="(navGroup.expand)?'show':''" [id]="navGroup.name"
        >
        <!-- <ul class="collapse list-unstyled" [ngClass]="(navGroup.expand)?'show':''" [id]="navGroup.title"
        *ngFor="let navItem of navGroup.navlinks"> -->
        <li>
          <a [routerLink]="[navItem.address]" routerLinkActive="active">{{navItem.name}}</a>
          <!-- <a [routerLink]="[navItem.linkInfo]" routerLinkActive="active">{{navItem.title}}</a> -->
        </li>
      </ul>
    }
  </li>
</ul>
}